/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations

==========================================================================================*/

import axios from "../../http/axios/index.js";

export default {
	SET_BEARER(state, accessToken) {
		localStorage.setItem("accessToken", accessToken);
		axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
	},

	SET_USER_PERMISSIONS(state, permissions) {
		state.userPermissions = permissions;
	},
	UPDATE_USER_SETTINGS(state, user_settings) {
		state.user_settings = user_settings;
	},
	UPDATE_DATETIMEFORMAT(state, datetimes) {
		state.datetimes = datetimes;
	},
	UPDATE_TIMEZONES(state, timezones) {
		state.timezones = timezones;
	},
	UPDATE_LOCALES(state, locales) {
		state.locales = locales;
	},
	UPDATE_USER_EMPLOYEE_POINTS(state, employee_points) {
		state.employee_points = employee_points;
	},
};
